import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parentesco'
})
export class ParentescoPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    switch (value) {
      case '0':
        return 'Mãe/Pai';
      case '1':
        return 'Avó/Mãe';
      case '2':
        return 'Tia/Tio';
      case '3':
        return 'Irmã/Irmão';
      case '4':
        return 'Prima/Primo';
    }
  }

}
